import { render, staticRenderFns } from "./TrackingIcon.vue?vue&type=template&id=1b20cd7d"
import script from "./TrackingIcon.vue?vue&type=script&lang=js"
export * from "./TrackingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports